// Curated adjective+noun display names (Docker/Heroku-style) used as the last-resort session title
// when the CLI never reported one and there's no cwd to derive a folder name from (#147). The pick is
// deterministic on the channelId so the same session keeps the same friendly name across reconnects.

const NAMES: readonly string[] = [
  'Quiet Comet',
  'Brave Otter',
  'Midnight Falcon',
  'Clever Sparrow',
  'Amber Fox',
  'Silent Harbor',
  'Golden Meadow',
  'Swift Heron',
  'Crimson Maple',
  'Frosty Pine',
  'Gentle Willow',
  'Bold Lantern',
  'Copper Canyon',
  'Velvet Thunder',
  'Lucky Pebble',
  'Restless River',
  'Cosmic Drift',
  'Hazy Summit',
  'Nimble Wren',
  'Radiant Dune',
  'Mellow Cedar',
  'Electric Robin',
  'Dusty Trail',
  'Sapphire Bay',
  'Wandering Kite',
  'Sunny Ledge',
  'Misty Grove',
  'Jolly Badger',
  'Iron Lotus',
  'Peaceful Ember',
  'Vivid Marsh',
  'Cobalt Wolf',
  'Rustic Anchor',
  'Breezy Orchard',
  'Stellar Moth',
  'Humble Acorn',
  'Emerald Finch',
  'Feral Compass',
  'Lofty Beacon',
  'Snowy Puffin',
  'Wild Meadowlark',
  'Tranquil Reef',
  'Scarlet Vale',
  'Nomad Sparrow',
  'Bright Tundra',
  'Quirky Newt',
  'Ashen Ridge',
  'Merry Otterling',
  'Silver Birch',
  'Vagrant Cloud',
  'Cheery Marmot',
  'Onyx Falcon',
  'Placid Lagoon',
  'Dapper Magpie',
  'Fabled Lantern',
  'Windward Sail',
  'Rosy Thicket',
  'Glacial Peak',
  'Brisk Sparrowhawk',
  'Amethyst Fen',
  'Wandering Yak',
  'Tidal Ember',
  'Curious Ferret',
  'Verdant Hollow',
  'Lunar Heron',
  'Rugged Basin',
  'Plucky Vole',
  'Coral Meridian',
  'Solemn Oak',
  'Zephyr Finch',
  'Marble Canyon',
  'Feisty Otter',
  'Twilight Reed',
  'Hearty Juniper',
  'Opal Current',
  'Nifty Sparrow',
  'Boreal Wolf',
  'Tender Bramble',
  'Vast Horizon',
  'Chipper Lark',
  'Ivory Delta',
  'Roaming Bison',
  'Cinder Peak',
  'Fleet Swallow',
  'Mossy Cove',
  'Bramble Fox',
  'Azure Comet',
  'Sturdy Elm',
  'Wispy Cloudlet',
  'Prancing Colt',
  'Slate Harbor',
  'Genial Otter',
  'Halcyon Bay',
  'Ruby Kestrel',
  'Drifting Dune',
  'Snug Burrow',
  'Vibrant Fern',
  'Quaint Cottage',
  'Nebula Wren',
  'Timber Wolf',
  'Serene Inlet',
];

/** Stable, non-cryptographic hash → index into NAMES (djb2). */
function hashIndex(input: string): number {
  let h = 5381;
  for (let i = 0; i < input.length; i++) {
    h = (h * 33) ^ input.charCodeAt(i);
  }
  return Math.abs(h) % NAMES.length;
}

/** Deterministically pick a friendly display name for a channelId. Same id → same name always. */
export function creativeName(channelId: string): string {
  if (NAMES.length === 0) return `Session ${channelId.slice(0, 6)}`;
  return NAMES[hashIndex(channelId)] ?? `Session ${channelId.slice(0, 6)}`;
}
